import React from 'react';

import type { Nullable } from '@clearverify/types';

import type { DemoCompanyEntityType } from 'src/constants/demoDashboardMode';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { isDemoCompanyEnabled } from 'src/utils/demoDashboardMode';

import { useDemoCompaniesId } from './useDemoCompaniesId';

export const useDemoDashboardEntityToggle = (
  entityType: DemoCompanyEntityType,
  entityId: Nullable<string>,
) => {
  const { hasPlatformRoles } = useCurrentUserPermissions();
  const { demoCompaniesId, setDemoCompanyIdEnabled } = useDemoCompaniesId();

  const isEnabled = isDemoCompanyEnabled(demoCompaniesId, entityType, entityId);

  const setEnabled = React.useCallback(
    (enabled: boolean) => {
      if (!entityId) return;
      setDemoCompanyIdEnabled(entityType, entityId, enabled);
    },
    [entityId, entityType, setDemoCompanyIdEnabled],
  );

  return React.useMemo(
    () => ({
      isAvailable: hasPlatformRoles && Boolean(entityId),
      isEnabled,
      setEnabled,
    }),
    [entityId, hasPlatformRoles, isEnabled, setEnabled],
  );
};
